/**
 * GA へ送る前に pathname からアクセストークンを除去する (JPTP_CANSEI-1400)。
 *
 * guest の URL 先頭セグメントは案件アクセストークンで、これ自体が認可の根拠
 * (ADR-011 / ゲストアプリの設計 §4.2)。GA4 は page_location を全イベントへ自動付与するため、
 * 素のまま送ると Google にトークンを渡すことになる。GA4 標準の Data Redaction は
 * メールアドレスとクエリパラメータのみが対象で **パスは扱えない** ため、ここで除去する。
 *
 * 店舗 ID / 商品 ID は個人を特定しないため残す (どの店舗・コースが見られたかの分析に使う)。
 *
 *   /{caseToken}/{shopId}/{productId}      -> /case/{shopId}/{productId}
 *   /reservations/{reservationToken}/cancel -> /reservations/cancel
 *   /nps/{npsToken}                         -> /nps
 */
export function redactPath(pathname: string): string {
  const segments = pathname.split("/").filter((segment) => segment.length > 0);
  const [first, ...rest] = segments;
  if (first === undefined) return "/";
  // 予約完了・キャンセル画面は /reservations/{予約トークン}/... の第 2 セグメントがトークン。
  if (first === "reservations") return ["/reservations", ...rest.slice(1)].join("/");
  // NPS アンケート画面は /nps/{npsToken} の第 2 セグメントがトークン (§6.7)。
  if (first === "nps") return ["/nps", ...rest.slice(1)].join("/");
  return ["/case", ...rest].join("/");
}

/**
 * 店舗詳細 (/{caseToken}/{shopId}) かどうか。
 *
 * この画面だけは page_view に店舗名を載せるため、店舗情報の取得完了後に ShopDetailView 自身が
 * 送る。router 直下の PageViewTracker では送らない (二重計上を防ぐ)。
 *
 * /reservations/{予約トークン} と /nps/{npsToken} も 2 セグメントだが店舗詳細ではないため、
 * 先頭セグメントで除外する (除外しないと page_view が送られなくなる)。
 */
export function isShopDetailPath(pathname: string): boolean {
  const segments = pathname.split("/").filter((segment) => segment.length > 0);
  return segments.length === 2 && segments[0] !== "reservations" && segments[0] !== "nps";
}
